import { render } from "./TradingChart.vue?vue&type=template&id=67bef1dc"
import script from "./TradingChart.vue?vue&type=script&lang=js"
export * from "./TradingChart.vue?vue&type=script&lang=js"

import "./TradingChart.vue?vue&type=style&index=0&id=67bef1dc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__